export const ArrowDownIcon = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4295 6.15888C12.4295 6.22969 12.3941 6.30935 12.341 6.36244L8.21617 10.4873C8.16305 10.5404 8.08339 10.5758 8.01258 10.5758C7.94177 10.5758 7.86211 10.5404 7.80898 10.4873L3.6842 6.36244C3.63108 6.30932 3.5957 6.22969 3.5957 6.15888C3.5957 6.08807 3.63108 6.00838 3.6842 5.95529L4.12677 5.51269C4.17989 5.4596 4.2507 5.42419 4.33036 5.42419C4.40117 5.42419 4.48083 5.4596 4.53395 5.51269L8.01258 8.99135L11.4912 5.51269C11.5443 5.4596 11.624 5.42419 11.6948 5.42419C11.7656 5.42419 11.8453 5.4596 11.8984 5.51269L12.341 5.95529C12.3941 6.00841 12.4295 6.08807 12.4295 6.15888Z"
      fill="black"
    />
  </svg>
);
